import { createContext, useContext } from 'react';
import { QueryClient } from '@tanstack/react-query';

// Module-level QueryClient + custom Context whose default value is the
// singleton. Lets id-resolver hooks work without a QueryClientProvider in
// the tree (production app root and component tests both render correctly).
const resolverClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5 * 60 * 1000, gcTime: 60 * 60 * 1000, retry: false, refetchOnWindowFocus: false }
  }
});

export const ResolverQueryClientContext = createContext(resolverClient);

export const getResolverClient = () => resolverClient;

export const useResolverQueryClient = () => useContext(ResolverQueryClientContext);

// Resolver-cache reset coordinator. Per-resolver modules register their own
// loader-clear callbacks at load time; consumers (logout, tenant switch)
// call `clearResolverCache()` to wipe everything in one shot.
const clearCallbacks = new Set();

export const registerResolverClearCallback = cb => {
  clearCallbacks.add(cb);
  return () => clearCallbacks.delete(cb);
};

export const clearResolverCache = () => {
  resolverClient.clear();
  clearCallbacks.forEach(cb => cb());
};
